export default {
  'meta': {
    'langName': 'CZECH',
    'lang': 'Čeština'
  },
  'title': 'STAŽENÍ Z PRODEJE PRODUKTU  BASKETBALOVÝ KOŠ B900 BOX NBA TARMAK ',
  'description': 'Dobrý den,\n\nNedávno jste si zakoupili basketbalový koš Tarmak B900\nBOX NBA a děkujeme Vám za váš nákup.\n\nV rámci našeho trvalého závazku ke kvalitě a bezpečnosti výrobků, \nidentifikoval tým Decathlonu potencionální riziko pádu vertikální tyče, pokud je odstraněna klička pro nastavení výšky a výrobek je následně používán nebo je s ním manipulováno.\n\nŽádáme Vás o zodpovězení několika otázek, abychom Vám mohli poskytnout vhodné bezpečnostní řešení pro váš výrobek.\n\nOmlouváme se za nepříjemnosti a děkujeme za vaši důvěru\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Nejprve prosím potvrďte svou emailovou adresu a zemi vašeho bydliště'
  },
  'fields': {
    'country': 'Země',
    'address': 'E-mail ',
    'email': 'E-mail ',
    'phonePrefix': 'Telefoní předvolba',
    'phone': 'Telefoní číslo',
    'validations': {
      'phoneOrEmail': 'Uveďte prosím alespoň emailovou adresu nebo telefoní číslo',
      'email': 'Zadejte prosím platnou emailovou adresu',
      'phone': 'Zadejte prosím platné telefoní číslo'
    },
    'firstName': 'Příjmení',
    'lastName': 'Jméno',
    'deliveryAddress': 'Adresa pro doručení balíčku',
    'additionalAddress': 'Další podrobnosti o adrese',
    'city': 'Město',
    'zip': 'PSČ',
    'choose': 'Vybrat',
    'required': 'Toto pole je povinné'
  },
  'ownerCheck': {
    'title': 'Vlastníte stále jeden nebo více basketbalových košů B900 BOX NBA?'
  },
  'yes': 'ANO',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Máte kontakt na součastného majitele/majitelku?',
    'confirmation': 'Pane/Paní\n\nDěkujeme za vaši účast v této iniciativě za kvalitu a bezpečnost.\n\nOmlouváme se za nepříjemnost a děkujeme za vaši důvěru\n\nDECATHLON'
  },
  'recall': {
    'title': 'Uveďte prosím počet basketbalových košů, které máte na základě typu instalované kličky',
    'descriptionRed': 'Basketbalový koš s odnímatelnou červenou kličkou',
    'descriptionBlack': 'Basketbalový koš s pevnou černou kličkou',
    'quantity': 'Počet',
    'notConcerned': 'Pane/Paní\n\nDěkujeme za vaši účast v této iniciativě za kvalitu a bezpečnost.\n\nMůžete si být jisti, váš basketbalový koš Tarmak B900 BOX NBA není ovlivněn procesem stahování z trhu. Je bezpečný k používání.\n\nOmlouváme se za nepříjemnost a děkujeme za vaši důvěru\n\nDECATHLON',
    'concernedProductQuantity': 'Množství neshodného produktu :',
    'concernedProductLabel': 'Neshodný produkt',
    'confirmation': 'Děkujeme za vyplnění tohoto formuláře. Vaše žádost byla úspěšně zaznamenána.\n\nCo nejdříve Vám zašleme sledovací číslo zásilky vaší opravné sady (prostřednictví Fandiwebu pro evropské země)\n\nPřejeme Vám hezký den\n\nDecathlon'
  },
  'repair': {
    'title': 'Oprava s vaší účastí',
    'description': 'Zjistili jsme riziko pádu vertikální tyče, pokud je na některých basketbalových koších Tarmak B900 BOX NBA (číslo produktu: 4239136) klička odstraněna a produkt je používán, nebo je s ním manipulováno. \nNa základě vaší odpovědi se zdá, že je tímto rizikem ovlivněn.\n\nŽádáme Vás proto, abyste jej okamžitě přestali používat, a nabízíme Vám pomoc s úpravou kličky tak, abyste mohli produkt bezpečně používat.\nUjišťujeme Vás, že tato oprava nevyžaduje žádné speciální odborné znalosti - vše je jasně vysvětleno ve videu a návodu k použití níže:',
    'videoLink': 'Odkaz pro video',
    'docLink': 'Odkaz pro návod',
    'callToAction': 'Klikněte zde a obdržíte bezplatnou opravnou sadu',
    'warranty': 'Na celý proces se vztahuje naše 5letá záruka'
  },
  'repairRequest': {
    'title': 'Zadejte prosím následující informace, aby Vám mohla být vaše bezplatná opravná sada zaslána na vámi zvolenou adresu:'
  },
  'form': {
    'submit': 'Další'
  },
  'status': 'Translation validated by COUNTRY'
} as const
